// eslint-disable-next-line max-classes-per-file
import { Uuid } from '@ftr/contracts/type/shared'

export interface CaseAction {
  readonly courtSystemId: Uuid
}

export class FetchActiveCaseAction implements CaseAction {
  static readonly type = '[Cases] Fetch Active Case'

  constructor(
    readonly courtSystemId: Uuid,
    readonly caseId: Uuid,
  ) {}
}

export class ClearActiveCaseAction implements CaseAction {
  static readonly type = '[Cases] Clear Active Case'

  constructor(readonly courtSystemId: Uuid) {}
}
